<template>
  <div>
    <PageAllow controller="DistributionMaterialAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <!-- 显示图表 -->
              <v-btn
                v-show="distribution_material_analyze.length"
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleBarEcharts')"
              >
                {{
                  $store.state.showBarEchartsPanel
                    ? $t("App.hideSparkline")
                    : $t("App.showSparkline")
                }}
                <v-icon small class="ps-1">{{
                  $store.state.showBarEchartsPanel
                    ? "fa-angle-up"
                    : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 按钮 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'DistributionMaterialAnalyze',
                    'summaryExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="summaryExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("MaterialDistribution.Export.summaryExcel") }}
              </v-btn>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'DistributionMaterialAnalyze',
                    'export'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("MaterialDistribution.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategoriesWithDescendants
                    v-model="materialCategorySelected"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="material"
                    v-model="options.keyword"
                    @text="orderCodeKeyword = $event"
                    :label="$t('MaterialDistribution.material_keyword')"
                  />
                </v-col>
                <!-- 销售 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops v-model="shopsSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings && settings.report_hide_search_district_tree == 2
                  "
                >
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 仓库 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" />
                </v-col>
                <!-- 线路 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistributionUsers
                    v-model="distributionUserSelected"
                    :searcherStocks="options.stock_ids"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherSelect
                    ref="brand"
                    v-model="options.brand"
                    :items="material_brands"
                    :label="$t('Material.brand')"
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <SearcherSuppliers
                    ref="supplierSelected"
                    v-model="supplierSelected"
                    :label="$t('Material.default_supplier')"
                  />
                </v-col>
                <!-- 状态 -->
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <!-- 使用 -->
                  <SearcherDistributionStatus
                    :items="$consts.distribution.distribution_status"
                    v-model="options.status"
                    :label="$t('MaterialDistribution.Fields.status')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- <v-expansion-panel
            v-show="sparklineValues.length > 1"
            class="transparent-background-color"
          >
            <v-expansion-panel-content>
              <BarSparkline
                :labels="sparklineLabels"
                :values="sparklineValues"
              />
            </v-expansion-panel-content>
          </v-expansion-panel> -->
          <v-expansion-panel
            v-show="sparklineValues.length"
            class="transparent-background-color"
          >
            <v-expansion-panel-content>
              <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
              <!-- <div id="chartBarBox" style="height: 45vh"></div> -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="distribution_material_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="5">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <!-- <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span> {{ order_total.total | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ order_total.price | formatMoney }}</span
                  >
                </td> -->
                <td></td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ distribution_total.total | formatTwoDot }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ distribution_total.price | formatMoney }}</span
                  >
                </td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialDistribution.Fields.order_num_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ distribution_total.total | formatTwoDot }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialDistribution.Fields.order_total_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ distribution_total.price | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialDistribution.Fields.num_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ order_total.total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MaterialDistribution.Fields.price_sum") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ order_total.price | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.standard_name="{ item }">
              <span v-if="item.standard_name && item.standard_name.length > 12" :title="item.standard_name" style="cursor: pointer">
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </template>
            <!-- 下单量 -->
            <template v-slot:item.order_num_sum="{ item }">
              {{ item.order_num_sum | formatTwoDot }}
            </template>
            <!-- 下单金额 -->
            <template v-slot:item.order_total_sum="{ item }">
              {{ $t("Global.money") }}{{ item.order_total_sum | formatMoney }}
            </template>
            <!-- 配送量 -->
            <template v-slot:item.num_sum="{ item }">
              {{ item.num_sum | formatTwoDot }}
            </template>
            <!-- 配送金额 -->
            <template v-slot:item.price_sum="{ item }">
              {{ $t("Global.money") }}{{ item.price_sum | formatMoney }}
            </template>
            <template v-slot:item.average_price="{ item }"
              >{{ $t("Global.money") }}
              {{ (item.price_sum / item.num_sum) | formatMoney }}
            </template>
            <!-- 明细 -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="
                      '/#/distribution-material-analyze/by-district-detail/' +
                      item.material_id +
                      '?auto_flg=' +
                      item.auto_flg
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("MaterialDistribution.Fields.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [
                    $t("MaterialDistribution.Fields.detail"),
                  ])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import DistributionMaterialAnalyze from "@/api/distribution_material_analyze";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistributionUsers from "@/components/plugins/SearcherDistributionUsers";
import SearcherDistributionStatus from "@/components/plugins/SearcherDistributionStatus";
// import BarSparkline from "@/components/plugins/BarSparkline";
import SearcherSelect from "@/components/plugins/SearcherSelect";
import Materials from "@/api/materials";
import BarEcharts from "@/components/plugins/BarEcharts";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers.vue";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  distribution_time_from: "",
  distribution_time_to: "",
  category_codes: [],
  alliance_business_ids: [],
  shop_ids: [],
  distribution_users: [],
  stock_ids: null,
  keyword: "",
  status: [1, 2, 3],
  brand: "",
  district_ids: [],
  default_supplier_ids: [],
};

export default {
  name: "stockDetails",
  data: () => ({
    distribution_material_analyze: [],
    stocksSelected: [],
    supplierSelected: [],
    orderCodeKeyword: "",
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    distribution_total: 0,
    order_total: 0,

    materialCategorySelected: [],
    alliancesSelected: null,
    shopsSelected: null,
    distributionUserSelected: null,
    material_brands: [],
    DistrictsSelected: [],
  }),
  components: {
    SearcherSuppliers,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherMaterialCategoriesWithDescendants,
    SearcherKeyword,
    SearcherStocks,
    SearcherAlliances,
    SearcherShops,
    SearcherDistributionUsers,
    SearcherDistributionStatus,
    // BarSparkline,
    SearcherSelect,
    BarEcharts,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    sparklineLabels() {
      return this.distribution_material_analyze.map((e) => {
        return e.material_name;
      });
    },
    sparklineValues() {
      return this.distribution_material_analyze.map((e) => {
        return parseFloat(e.order_total_sum);
      });
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialDistribution"),
        disabled: true,
        href: "/distribution_material_analyze",
      },
    ],
    datetimeRadios: () => [
      {
        key: "create",
        text: i18n.t("MaterialDistribution.Fields.created_date"),
      },
      {
        key: "distribution",
        text: i18n.t("MaterialDistribution.Fields.distribution_date"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("MaterialDistribution.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("MaterialDistribution.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("MaterialDistribution.Fields.standard_name"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("MaterialDistribution.Fields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("MaterialDistribution.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      // {
      //   text: i18n.t("MaterialDistribution.Fields.order_average_price"),
      //   align: "end",
      //   sortable: false,
      //   value: "order_average_price",
      // },
      // // 下单量
      // {
      //   text: i18n.t("MaterialDistribution.Fields.order_num_sum"),
      //   align: "end",
      //   sortable: false,
      //   value: "order_num_sum",
      // },
      // // 下单金额
      // {
      //   text: i18n.t("MaterialDistribution.Fields.order_total_sum"),
      //   align: "end",
      //   sortable: false,
      //   value: "order_total_sum",
      // },
      // 配送均价
      {
        text: i18n.t("MaterialDistribution.Fields.averagePrice"),
        align: "end",
        sortable: false,
        value: "average_price",
      },
      // 配送量
      {
        text: i18n.t("MaterialDistribution.Fields.num_sum"),
        align: "end",
        sortable: false,
        value: "num_sum",
      },
      // 配送金额
      {
        text: i18n.t("MaterialDistribution.Fields.price_sum"),
        align: "end",
        sortable: false,
        value: "price_sum",
      },
      // 操作
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["settings", "districtID"]),
  },

  mounted() {
    Materials.fetchFiledSelects({
      field_names: ["brand"],
    }).then(
      function (response) {
        if (response.data.status.isOK()) {
          this.material_brands = response.data.brand;
        }
      }.bind(this)
    );
    this.$store.commit("districtID", 0);
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("districts_material_sales", [
        "materialCategorySelected",
        "stocksSelected",
        "alliancesSelected",
        "shopsSelected",
        "distributionUserSelected",
        "DistrictsSelected",
        "supplierSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          if (this.$route.query && this.$route.query.created_date) {
            this.options.datetimeRadioSelected = "create";
            this.options.create_time_from =
              this.$route.query.created_date + " 00:00:00";
            this.options.create_time_to =
              this.$route.query.created_date + " 23:59:59 ";
            this.$router.replace("/distribution-material-analyze");
          }
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "materialCategorySelected":
                this.materialCategorySelected = selected.value;
                break;
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "distributionUserSelected":
                this.distributionUserSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
              case "supplierSelected":
                this.supplierSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign(this.options, {
        keyword: this.orderCodeKeyword,
      });
      this.getDistributionMAFromAPI();
    },
    resetSearch() {
      this.stocksSelected = [];
      this.supplierSelected = [];
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.distributionUserSelected = [];
      this.materialCategorySelected = [];
      this.DistrictsSelected = [];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.brand].forEach((k) => {
        if (k) k.clear();
      });
    },
    getDistributionMAFromAPI() {
      this.loading = true;
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      DistributionMaterialAnalyze.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distribution_material_analyze =
              response.data.distribution_material_analyze;
            this.distribution_total = response.data.distribution_total;
            this.order_total = response.data.order_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    summaryExportExcel(){
      DistributionMaterialAnalyze.summaryExports(this.options);
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      DistributionMaterialAnalyze.exports(options);
    },
  },
  watch: {
    $route() {
      if (this.$route.query && this.$route.query.created_date) {
        this.options.datetimeRadioSelected = "create";
        this.options.create_time_from =
          this.$route.query.created_date + " 00:00:00";
        this.options.create_time_to =
          this.$route.query.created_date + " 23:59:59 ";
        this.$router.replace("/distribution-material-analyze");
      }
    },
    districtID: {
      handler() {
        this.getDistributionMAFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getDistributionMAFromAPI();
        sessionStorage.setItem(
          "districts_material_sales-options",
          JSON.stringify(this.options)
        );
      },
    },

    // 商品分类
    materialCategorySelected: {
      handler() {
        this.options.category_ids = this.materialCategorySelected.map(
          (category) => category.id
        );
        sessionStorage.setItem(
          "districts_material_sales-materialCategorySelected",
          JSON.stringify(this.materialCategorySelected)
        );
      },
    },
    // 配送线路
    distributionUserSelected: {
      handler() {
        this.options.distribution_users = this.distributionUserSelected
          ? this.distributionUserSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "districts_material_sales-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },

    // 仓库
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected.map((e) => e.id);
        sessionStorage.setItem(
          "districts_material_sales-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    supplierSelected: {
      handler() {
        this.options.default_supplier_ids = this.supplierSelected.map((s) => s.id);
        sessionStorage.setItem(
            "districts_material_sales-supplierSelected",
            JSON.stringify(this.supplierSelected)
        );
      },
    },
    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "districts_material_sales-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "districts_material_sales-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (
          this.settings &&
          this.settings.report_hide_search_district_tree == 2
        ) { 
          this.options.district_ids = this.DistrictsSelected
          ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
          : [];
          sessionStorage.setItem(
            "districts_material_sales-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>

<style>
</style>